// @flow

import React, { Component, Children, type Node } from 'react';
import _ from 'lodash';
import CookieBanner from 'client/components/banner/CookieBanner';
import HtmlHead from 'client/components/htmlHead';
import NpnFooter from 'client/components/npnFooter';
import { fetchMembers } from 'client/actions/members';
import { fetchUser } from 'client/actions/user';
import { fetchConfiguration } from 'client/actions/enterprise/user';
import { fetchContentful } from 'client/actions/contentful';
import CONTENTFUL_ENTRY_ID from 'client/constants/contentfulEntry';
import StrideHeaderWrapper from 'client/components/strideHeaderWrapper';
import 'client/styles/common.scss';

type Props = {
  children: Node,
};

class App extends Component<Props> {
  static fetchData({ dispatch }: { dispatch: Object }) {
    return Promise.all([
      dispatch(fetchMembers()),
      dispatch(fetchUser()),
      dispatch(fetchConfiguration()),
    ]).then((response) => {
      const locale = _.get(response, '[1].locale', 'en-US');
      return dispatch(fetchContentful(CONTENTFUL_ENTRY_ID.COVID_19_SUPPORT_HUB, locale));
    });
  }

  render() {
    return (
      <StrideHeaderWrapper showPhone={false} noShadow>
        <HtmlHead
          title="Stride COVID-19 Support"
          description="We’re here for you in this time of uncertainty. Check out our independent workers COVID-19 guide for navigating all things health, tax, and financial support." />
        {Children.only(this.props.children)}
        <CookieBanner />
        <NpnFooter showPhone={false} />
      </StrideHeaderWrapper>
    );
  }
}

export default App;
